import { logger } from './Helpers';

/**
 * @class ConfigurationManager
 * @description Manage all the aspects related to configuration manipulation
 */
export default class ConfigurationManager {
    constructor(config) {
        if (!this.validate(config)) {
            throw new Error('[RcsOrchestrator] Configuration not valid');
        }

        this.config = this.enrichConfiguration(config);
    }

    /**
     * Enrich configuration object with usefull external details
     * @param {Object} config configuration to enrich
     */
    enrichConfiguration(config) {
        //  Add hashes to associate cache keys
        if (config.cacheKeysMapVar && window[config.cacheKeysMapVar]) {
            logger.log(
                '%c ORCHESTRATOR ',
                'color: white; background-color: #2274A5',
                `Object ${config.cacheKeysMapVar} found in page. Applying cache keys...`
            );
            this.cacheKeysMapVar = window[config.cacheKeysMapVar];
            config.components.forEach((component) => {
                if (component.id && this.cacheKeysMapVar[component.id]) {
                    component.src = `${component.src}?v=${this.cacheKeysMapVar[component.id]}`;
                }
            });
        }

        return config;
    }

    getComponents() {
        const flavor = this.getFlavor();

        if (!flavor) return this.config.components;
        const components = [];

        this.config.components.forEach((component) => {
            if (!component.flavors || component.flavors.indexOf(flavor) > -1) {
                components.push(component);
            }
        });

        return components;
    }

    getFlavor() {
        return this.config.getFlavor ? this.config.getFlavor() : null;
    }

    /**
     * Validate the minimum requirement for config
     * @param {Object} config
     * @returns {Boolean} true if configuration is valid
     */
    validate(config) {
        if (config && config.components) {
            return true;
        }

        return false;
    }
}
